<template>
    <div class="dark">
        <div class="h-screen bg-gray-200 dark:bg-gray-800 transition duration-500 ease-in-out flex overflow-hidden">
            <Head :title="title" />
            <!-- Static sidebar for desktop -->
            <div class="hidden lg:flex lg:shrink-0" v-if="$page.props.user.play_tokens || $page.props.user.has_bets">
                <div class="flex flex-col" :class="showNavBarText ? 'w-[230px]':'w-[62px]'">
                    <!-- Sidebar component, swap this element with another sidebar if you like -->
                    <div class="flex-1 flex flex-col min-h-0">
                        <!-- {{ $page.props.settings.site_name }} -->
                        <div class="flex items-center h-16 shrink-0 p-1 bg-black">
                            <Link class="block w-full" method="get" :href="route('dashboard')">
                                <!-- <img class="w-14" :src='images/logos/racingstars.svg' alt="$page.props.settings.site_name"> -->
                                <img v-if="!$page.props.features.custom_nav_bar && $page.props.settings.site_name == 'Racing Stars'"  class="w-14" src='../../images/logos/racingstars.svg' alt="$page.props.settings.site_name">        
                                <img v-else-if="$page.props.features.custom_nav_bar" class="h-16 w-auto sm:h-18" :src="asset('images/racingleague/racingleague-live.png')" />
                                <img v-else-if="$page.props.settings.site_name == 'Zilliqa'" class="h-16 w-auto sm:h-18 object-contain" :src="asset('images/logos/twc-the-game.png')" />

                            </Link>
                        </div>
                        <div class="flex-1 flex flex-col" :class="[isStaging ? 'border-blue-400' : 'border-racing-stars-yellow', $page.props.settings.site_name == 'Zilliqa' ? 'border-0' : 'border-r-2 ']">
                            <nav :class="[$page.props.settings.site_name == 'Zilliqa' ? 'bg-black' : 'bg-gray-900', 'flex-1 lg:px-2 lg:py-2 bg-black space-y-3']" v-if="menus.length > 0">
                               <Link :id="item.name=='Support' ? 'chat' : ''" :as="getElement(item.method)" v-for="item in menus" :key="item.id" :method="getMethod(item.method)" :href="getRoute(item.route)" :class="[isLink(item.route) ? 'bg-racing-stars-yellow text-gray-900' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full cursor-pointer mx-auto', item.name === 'Information' ? 'hidden' : '', item.name === 'Support' ? 'mb-1' : '']">
                                <component v-if="showNavBarText" :is="item.icon" :class="[isLink(item.route) ? 'text-gray-900' : 'text-gray-400 group-hover:text-gray-300', 'shrink-0 h-7 w-7']" aria-hidden="true" />
                                    <popper v-else offsetDistance="0" hover placement="right"  style="--popper-theme-background-color:#1f2937; margin : 0px; border : 0px; padding : 0px; --popper-theme-border-width : 2px; --popper-theme-border-color : #353e4e">
                                        <component :is="item.icon" :class="[isLink(item.route) ? 'text-gray-900' : 'text-gray-400 group-hover:text-gray-300', 'shrink-0 h-7 w-7']" aria-hidden="true" />
                                        <template #content>
                                            <p class="text-sm font-bold text-gray-200 text-center max-w-sm">
                                                {{ item.name }}
                                            </p>
                                        </template>
                                    </popper>

                                    <p v-if="showNavBarText" class="text-sm font-bold text-center max-w-sm pl-3" :class="[isLink(item.route) ? 'text-gray-900' : 'text-gray-200']">
                                        {{ item.name }}
                                    </p>
                                </Link>
                                <!-- Info dropdown -->
                                <Menu as="div" class="cursor-pointer text-white flex relative">
                                    <MenuButton as="div" class="w-full" >
                                        <div :class="[isLink('information') ? 'bg-racing-stars-yellow text-gray-900' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md w-full cursor-pointer mx-auto']">
                                            <InformationCircleIcon :class="[isLink('information') ? 'text-gray-900' : '']" class="text-gray-400 group-hover:text-gray-300 shrink-0 h-7 w-7"/>
                                            <p v-if="showNavBarText" class="text-sm font-bold text-center max-w-sm pl-3" :class="[isLink('information') ? 'text-gray-900' : 'text-gray-200']">
                                                Information
                                            </p>
                                        </div>
                                    </MenuButton>
                                    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                        <div class="flex absolute w-44" :class="[showNavBarText ? 'bottom-0' : 'top-0']">
                                            <MenuItems as="div" class="absolute left-0 z-10 bg-gray-900 text-gray-300 p-1 rounded-md w-full font-medium text-sm border shadow-xl" :class="[showNavBarText ? 'mt-5' : 'left-10 ml-5 mt-0']">
                                                <a href="/privacy">
                                                    <MenuItem as="div" v-slot="{ active }" class="text-sm border-b py-1 font-semibold">Privacy</MenuItem>
                                                </a>
                                                <a href="/terms">
                                                    <MenuItem as="div" v-slot="{ active }" class="text-sm py-1 font-semibold">Terms & Conditions</MenuItem>
                                                </a>
                                            </MenuItems>
                                        </div>
                                    </transition>
                                </Menu>
                            </nav>

                            <div v-if="isBeta" class="bg-racing-stars-yellow text-center font-bold text-xs">
                                PRE-RELEASE BETA
                            </div>

                            <button v-if="$page.props.settings.site_name != 'Zilliqa'" @click="toggleNavBarText()" class="shrink-0 flex h-11 items-center justify-center bg-gray-900">
                                <div class="flex items-center text-gray-400 hover:text-gray-200" :class="showNavBarText ? 'mr-auto' : 'mx-auto'">
                                    <div class="text-xs font-medium text-left mx-auto p-2 px-4">
                                        <ChevronRightIcon class="h-6 w-6 " :class="showNavBarText ? 'rotate-180 transform' : ''"/>
                                    </div>

                                    <p v-if="showNavBarText" class="text-sm font-bold text-center max-w-sm">
                                        Minimise
                                    </p>
                                </div>
                            </button>

                            <button v-if="false" class="shrink-0 flex h-12 items-center justify-center bg-gray-900 mb-1">
                                <div class="flex items-center text-gray-400" :class="showNavBarText ? 'mr-auto' : 'mx-auto'">
                                    <Menu>
                                        <MenuButton class="flex justify-start hover:text-gray-200">
                                            <div class="text-xs font-medium text-left p-4 flex mx-auto">
                                                <UserGroupIcon class="h-6 w-6 my-auto"/>
                                            </div>
                                            <p v-if="showNavBarText" class="my-auto text-sm font-bold text-center max-w-sm">
                                                Show Friends
                                            </p>
                                        </MenuButton>
                                        <MenuItems class="z-20 absolute bottom-0 left-52 bg-gray-900 text-white border border-racing-stars-yellow rounded-md px-2 pt-2 w-80 cursor-default max-h-96 overflow-x-scroll" :class="showNavBarText ? 'left-52' : 'left-[72px]'">
                                            <Menu as="div" :class="$page.props.friendRequestsCount === 0 ? 'hidden' : 'border-b'">
                                                <MenuButton as="button" class="flex m-2 pt-2 font-medium" @click="() => (open = !open)">
                                                    Friend Requests ({{ $page.props.friendRequestsCount }})
                                                    <ChevronDownIcon class="h-6 w-6 pl-2" :class="open ? '-rotate-180 pr-2 pl-0' : ''"></ChevronDownIcon>
                                                </MenuButton>
                                                <div class="w-full pb-2">
                                                    <MenuItems class="flex flex-col max-w-full justify-between">
                                                        <MenuItem v-for="request in $page.props.friendRequests" as="div" class="flex m-2 justify-between">
                                                            <span class="flex">
                                                                <!-- <span class="w-10 h-10 rounded-full bg-white mr-4 shrink-0">
                                                                    <img class="rounded-full h-10 w-10 object-cover" src="https://www.w3schools.com/images/lamp.jpg"/>
                                                                </span> -->
                                                                <p class="my-auto mr-4 break-all">{{ request.user.username }}</p>
                                                            </span>
                                                            <span class="flex justify-end">
                                                                <CheckIcon class="mr-2 h-6 w-6 my-auto text-green-500 stroke-current cursor-pointer" @click="accept(request.sender_id)"></CheckIcon>
                                                                <XIcon class="h-6 w-6 my-auto text-red-500 stroke-current cursor-pointer" @click="deny(request.sender_id)"></XIcon>
                                                            </span>
                                                        </MenuItem>
                                                    </MenuItems>
                                                </div>
                                            </Menu>
                                            <div>
                                                <span class="flex m-2 pt-2 font-medium">Recently Active <span class="ml-2 w-3 h-3 bg-green-500 my-auto rounded-full"></span></span>
                                                <MenuItem v-for="friend in $page.props.friends" as="div" class="pt-2 m-2 flex justify-between" :class="[moment.duration(moment().diff(friend.last_logged_in, moment(moment().subtract(10, 'minutes')))) < moment.duration(moment().diff(moment().subtract(30, 'minutes'))) ? '' : 'hidden']">
                                                    <span class="flex w-10 h-10 rounded-full shrink-0">
                                                        <!-- <img class="rounded-full h-10 w-10 object-cover mr-4" :src="friend.profile_photo_path"/> -->
                                                        <p class="my-auto">{{ friend.username }} </p>
                                                    </span>
                                                </MenuItem>
                                            </div>
                                        </MenuItems>
                                    </Menu>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Content area -->
            <div class="flex-1 flex flex-col overflow-hidden ">
                <header class="w-full border-racing-stars-yellow" :class="[isStaging ? 'border-blue-400' : 'border-racing-stars-yellow', $page.props.settings.site_name == 'Zilliqa' ? 'border-0' : 'border-b-2 ']">
                    <div class="relative z-10 shrink-0 h-16 transition duration-500 ease-in-out bg-black shadow-sm flex">
                        <div class="flex-1 flex justify-between px-4 sm:px-6 pr-1 sm:pr-1">
                            <div class="lg:hidden w-12 items-center h-16 shrink-0 py-2">
                                <Link class="block" method="get" :href="route('dashboard')">
                                    <img v-if="!$page.props.features.custom_nav_bar && $page.props.settings.site_name == 'Racing Stars'"  class="w-14" src='../../images/logos/racingstars.svg' alt="$page.props.settings.site_name">        
                                    <img v-else-if="$page.props.features.custom_nav_bar" class="h-16 w-auto sm:h-18" :src="asset('images/racingleague/racingleague-live.png')" />
                                    <img v-else-if="$page.props.settings.site_name == 'Zilliqa'" class="h-12 w-auto sm:h-18 object-contain" :src="asset('images/logos/zilliqa-logo.png')" />
                                </Link>
                            </div>
                            <div class="flex-1 flex"></div>
                            <div class="flex items-center space-x-2 sm:space-x-6">
                                <!-- <span class="md:inline-block hidden" v-if="$page.props.racingstars.site ==='racingstars'">
                                    <a class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black bg-racing-stars-yellow hover:text-gray-500" href="/store"> Buy Tokens </a>
                                </span> -->
                                <span class="inline-flex" v-if="$page.props.racingstars.site ==='racingstars'">
                                    <Link method="get" :href="route('tokens')" class="p-1 rounded-full text-gray-400 transition duration-500 ease-in-out dark:text-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:racing-stars-yellow">
                                    <span class="sr-only">Purchase stars</span>
                                        <!-- <div class="flex mr-3 justify-center items-center text-white">
                                            <DatabaseIcon class="h-4 w-4 mr-3 md:w-6 md:h-6" aria-hidden="true" />
                                            {{ tokens }}
                                        </div> -->
                                </Link>
                                </span>

                                <span class="inline-flex" v-if="$page.props.user.balance > 0 && windowWidth > 480">
                                    <Link method="get" :href="route('account')" class="p-1 rounded-full text-gray-400 transition duration-500 ease-in-out dark:text-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:racing-stars-yellow">
                                    <span class="sr-only">View your balance</span>
                                    <div class="flex justify-center items-center">

                                    </div>
                                    </Link>
                                </span>

                                <span class="border-[3px] border-racing-stars-yellow rounded-full p-1 overflow-hidden text-sm m-0" v-if="$page.props.racingstars.site ==='racingstars'">
                                    <div class="flex flex-row text-gray-200">
                                        <a class="my-auto" href="/store">
                                            <PlusCircleIcon class="w-7 h-7 mr-1 text-racing-stars-yellow" href="/store" />
                                        </a>
                                        <span class="inline-flex">
                                            <img class="w-6 h-6 my-auto" :src="asset('images/coin-and-tokens/token-optimised.svg')" />
                                            <p class="font-bold align-center my-auto mx-2 ml-1 text-xs">{{tokens}}</p>
                                        </span>

                                        <span class="inline-flex" v-if="$page.props.user.balance > 0">
                                            <div class="flex justify-center items-center">
                                                <img class="w-6 h-6 my-auto ml-1" :src="asset('images/coin-and-tokens/cash.svg')"  alt="Cash Balance"/>
                                                <p class="font-bold align-center my-auto text-sm mx-1 text-xs">{{ formatter.format($page.props.user.balance / 100) }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </span>

                                <!-- <span class="inline-flex">
                                    <button type="button" class="-mx-1 p-1 rounded-full text-gray-400 hover:text-gray-500" @click="showNotifications = !showNotifications">
                                        <span v-if="newNotification || unreadNotifications" class="animate-ping absolute inline-flex rounded-full bg-racing-stars-yellow w-2 h-2 opacity-75"></span>
                                        <span class="sr-only">View notifications</span>
                                        <BellIconSolid v-if="newNotification || unreadNotifications" class="h-6 w-6 transition duration-500 ease-in-out dark:text-white" aria-hidden="true" />
                                        <BellIcon v-else class="h-6 w-6 transition duration-500 ease-in-out dark:text-white" aria-hidden="true" />
                                    </button>
                                </span> -->

                                <span v-if="user.is_admin" class="inline-flex">
                                    <a href="/admin">
                                        <button type="button" class="-mx-1 p-1 rounded-full text-gray-400 hover:text-gray-500" >
                                            <CogIcon class="h-6 w-6 transition duration-500 ease-in-out dark:text-white" aria-hidden="true" />
                                        </button>
                                    </a>
                                </span>

                                <span v-if="$page.props.features.exp == false" class="inline-flex">
                                    <p class="font-bold text-center align-middle text-white">{{$page.props.user.username}}</p>
                                </span>

                                <!-- Profile dropdown -->
                                <Menu as="div" class="relative shrink-0">
                                    <div class="pt-1">
                                        <div>
                                            <div class="inline-flex relative w-fit m-auto mr-1">
                                                <Menu as="div" class="absolute inline-block top-12 right-12 bottom-auto
                                                 left-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0
                                                  scale-x-120 scale-y-70 py-0.5 px-1.5 text-md leading-none text-center
                                                   whitespace-nowrap align-baseline font-bold bg-gray-800
                                                    text-racing-stars-yellow rounded-full z-10 text-centre"
                                                      v-if="$page.props.features.exp == true"
                                                >
                                                    <MenuButton>
                                                        {{level.level}}
                                                    </MenuButton>
                                                    <MenuItems class="origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                        <MenuItem as="div" class="h-20 font-medium">
                                                            <h3 class="mb-4 mt-2 text-black">Level: {{ level.level }}</h3>
                                                            <div class="h-2 bg-gray-500 rounded-md mx-4 my-auto mb-4">
                                                                <div class="h-2 bg-racing-stars-yellow rounded-md" :style="'width:'+((level.exp-level.prev) / (level.nextlevelxp-level.prev) * 100)+'%;'"> </div>
                                                            </div>
                                                            <span class="text-black">{{ level.nextlevelxp - level.exp }} XP until level {{ level.level + 1 }}</span>
                                                        </MenuItem>
                                                    </MenuItems>
                                                </Menu>

                                                <radial-progress-bar class="m-auto" :diameter="55"
                                                                     :completed-steps="level.exp - level.prev"
                                                                     :total-steps="level.nextlevelxp - level.prev"
                                                                     :strokeWidth="5" :innerStrokeWidth="5"
                                                                     :startColor="$page.props.settings.primary_color"
                                                                     :stopColor="$page.props.settings.primary_color"
                                                                     v-if="$page.props.features.exp == true"
                                                >
                                                    <MenuButton v-if="$page.props.jetstream.managesProfilePhotos" class="bg-black rounded-full flex text-sm m-auto">
                                                        <span class="sr-only">Open user menu</span>
                                                        <span class="flex mx-auto justify-center rounded-full shrink-0">

                                                            <img class="relative rounded-full shadow-lg mx-auto h-9 w-9 object-cover" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />
                                                        </span>
                                                    </MenuButton>
                                                    <MenuButton v-else class="inline-flex items-center px-3 py-2 border text-sm leading-4 font-medium rounded-md text-gray-500 hover:text-gray-700 focus:outline-none transition m-auto">
                                                        {{ $page.props.user.name }}
                                                        <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                        </svg>
                                                    </MenuButton>
                                                </radial-progress-bar>
                                                <span v-else-if="$page.props.features.exp != true">
                                                    <MenuButton v-if="$page.props.jetstream.managesProfilePhotos" class="bg-black rounded-full flex text-sm m-auto w-10">
                                                        <span class="sr-only">Open user menu</span>
                                                        <span class="flex mx-auto justify-center rounded-full shrink-0">
                                                            <img class="relative rounded-full shadow-lg mx-auto h-11 w-11 object-cover mr-2" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />
                                                        </span>
                                                    </MenuButton>
                                                    <MenuButton v-else class="inline-flex items-center px-3 py-2 border text-sm leading-4 font-medium rounded-md text-gray-500 hover:text-gray-700 focus:outline-none transition m-auto">
                                                        {{ $page.props.user.name }}
                                                        <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                        </svg>
                                                    </MenuButton>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                        <MenuItems class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <MenuItem v-for="item in userNavigation" :key="item.name">
                                                <a v-if="item.route === 'logout'" href="#" @click="logout()" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition cursor-pointer">{{ item.name }}</a>
                                                <Link v-else v-show="!(item.route === 'affiliates' && $page.props.settings.site_name === 'Racing League')" :method="item.method" :href="route(item.route)" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition cursor-pointer" as="link">
                                                    {{ item.name }}
                                                </Link>
                                            </MenuItem>
                                        </MenuItems>
                                    </transition>
                                </Menu>
                            </div>
                        </div>
                    </div>
                </header>

                <span v-if="message.error" class="flex w-full h-fit p-4 bg-red-500 text-white ">
                    <InformationCircleIcon class="w-8"/>
                    <p class = "font-bold h-fit my-auto ml-2">{{message.error}}</p>
                </span>
                <jet-banner v-else :passed-message="message" class="w-full" />

                <!-- Main content -->
                <main :class="[isSafariWithNav ? 'pb-32' : $page.props.settings.site_name == 'Zilliqa' ? 'bg-black' : '', 'flex flex-col overflow-y-scroll overflow-x-hidden pb-32 lg:mb-0 lg:pb-0 h-full']">
                    <!-- Primary column -->
                    <section class="grow">
                        <slot></slot>
                    </section>
                </main>
            </div>
            <div class="fixed bottom-0 w-full lg:hidden" :class="[isStaging || isBeta ? 'h-20' : 'h-16']">
                <div v-if="isStaging" class="bg- bg-blue-400 text-center font-bold text-xs pl-4 ">
                    STAGING SERVER
                </div>
                <div v-if="isBeta" class="bg-racing-stars-yellow text-center font-bold text-xs pl-4 ">
                    PRE-RELEASE BETA
                </div>

                <nav class="flex justify-center" :class="$page.props.settings.site_name == 'Zilliqa' ? 'bg-black' : 'bg-gray-900'">
                    <Link   :id="!item.method ? 'chat' : ''" :as="getElement(item.method)" v-for="item in menus" :key="item.name" :method="getMethod(item.method)" :href="getRoute(item.route)" :class="[isLink(item.route) ? 'bg-racing-stars-yellow text-gray-900' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group items-center justify-center p-1 py-2 grow text-center mx-1 block', item.name === 'Information' ? 'hidden' : '']">
                        <component :is="item.icon" :class="[isLink(item.route) ? 'text-gray-900' : 'text-gray-400 group-hover:text-gray-300 ', 'shrink-0 h-8 w-8 mx-auto']" aria-hidden="true" />
                        <p class="text-[10px] mt-1 font-semibold">{{item.name}}</p>
                    </Link>
                    <Menu as="div" class="text-gray-300 hover:bg-gray-700 hover:text-white group items-center justify-center p-1 py-2 grow text-center rounded-md mx-1 block">
                        <MenuButton as="div" class="w-full" >
                            <div :class="[isLink('information') ? 'bg-racing-stars-yellow text-gray-900' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group flex flex-col items-center text-sm font-medium rounded-md cursor-pointer mx-auto']">
                                <InformationCircleIcon :class="[isLink('information') ? 'text-gray-900' : '']" class="text-gray-400 group-hover:text-gray-300 shrink-0 h-8 w-8"/>
                                <p class="text-[10px] font-bold text-center max-w-sm mt-[2px]" :class="[isLink('information') ? 'text-gray-900' : 'text-gray-300']">
                                    Information
                                </p>
                            </div>
                        </MenuButton>
                        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                            <MenuItems as="div" class="absolute bottom-20 right-0 mb-5 bg-gray-900 text-gray-300 p-2 rounded-md font-medium text-sm border mr-2">
                                <a href="/privacy">
                                    <MenuItem as="div" v-slot="{ active }" class="text-base py-2 border-b">Privacy</MenuItem>
                                </a>
                                <a href="/terms">
                                    <MenuItem as="div" v-slot="{ active }" class="text-base py-2">Terms & Conditions</MenuItem>
                                </a>
                            </MenuItems>
                        </transition>
                    </Menu>
                </nav>
            </div>
            <tw-modal :padding="true" title="Need a Break?" subtitle="You have been logged in for a while now, would you like to take a break?" :show="showLogoutModal" @close="showLogoutModal = false">
                <div class="flex justify-center mt-4">
                    <tw-button class="mr-4" :secondary="true" @click="showLogoutModal = false">No</tw-button>
                    <Link class="text-right disabled:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed inline-flex font-semibold justify-center items-center border border-transparent font-medium shadow-sm text-white
                bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 transition duration-500 ease-in-out dark:bg-racing-stars-yellow dark:text-gray-800 dark:hover:bg-opacity-80 py-2 px-4 rounded" method="post" :href="logout()" as="link">Yes</Link>
                </div>
            </tw-modal>
            <!-- <fab v-if="notMobile && !$page.props.user.active_bet && route().current() !== 'play' && $page.props.user.play_tokens" /> -->
            <notifications :notifications="store.getters.notifications" :show="showNotifications" @close="showNotifications = false" @deleteNotification="deleteNotification($event)" @updateNotification="updateNotification($event)" />
            <toast :show="showToast" @close="showToast = false" />
        </div>
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import { ref, reactive, onMounted, computed, getCurrentInstance, watch, watchEffect } from 'vue'
import TwModal from '@/Global/Elements/TwModal'
import TwButton from '@/Global/Elements/TwButton'
import RadialProgressBar from 'vue-radial-progress'
import Popper from "vue3-popper"
import { ChevronUpIcon, PlusCircleIcon, UsersIcon, CheckIcon, InformationCircleIcon } from '@heroicons/vue/outline'

import {
    Dialog,
    DialogOverlay,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'

import {
    DatabaseIcon,
    CashIcon,
    BellIcon,
    CogIcon,
    CollectionIcon,
    MenuAlt2Icon,
    PhotographIcon,
    PlusIcon,
    UserGroupIcon,
    HomeIcon,
    AnnotationIcon,
    ClipboardListIcon,
    CalendarIcon,
    PlayIcon,
    InboxIcon,
    ChatIcon,
    UserIcon,
    XIcon,
    PresentationChartLineIcon,
    ClipboardCheckIcon,
    ShoppingCartIcon,
    QuestionMarkCircleIcon,
    ChartBarIcon,

} from '@heroicons/vue/outline'

import {
    BellIcon as BellIconSolid,
} from '@heroicons/vue/solid'

import { SearchIcon } from '@heroicons/vue/solid'
import Fab from '@/Global/Fab'
import Notifications from '@/Global/Notifications'
import Toast from '@/Global/Toast'
import TwToggleIcon from '@/Global/Elements/TwToggleIcon'
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
import ApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetTextarea from '@/Jetstream/Textarea'
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from '@/Jetstream/Label'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import { usePage } from '@inertiajs/inertia-vue3'
import { useStore } from 'vuex'
import moment from 'moment'
import { useGtm } from '@gtm-support/vue-gtm'
import { Inertia } from '@inertiajs/inertia'
import {ChevronRightIcon, ChevronDownIcon, GiftIcon} from '@heroicons/vue/outline'

export default {
    props: {
        user: Object,
        racingstars: Object,
        jetstream: Object,
        title: String,
        friends: Object,
        friendsCount: Object,
        friendRequests: Object,
        friendRequestsCount: Object,
    },
    components: {
        Head,
        ApplicationLogo,
        ApplicationMark,
        Notifications,
        Toast,
        Link,
        Dialog,
        DialogOverlay,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        MenuAlt2Icon,
        BellIcon,
        CogIcon,
        BellIconSolid,
        PlusIcon,
        SearchIcon,
        HomeIcon,
        UserIcon,
        AnnotationIcon,
        ClipboardListIcon,
        CalendarIcon,
        PlayIcon,
        XIcon,
        JetBanner,
        JetButton,
        JetInput,
        JetTextarea,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        JetDropdownLink,
        DatabaseIcon,
        CashIcon,
        ChatIcon,
        Fab,
        TwToggleIcon,
        TwModal,
        TwButton,
        RadialProgressBar,
        Popper,
        PlusCircleIcon,
        ChevronRightIcon,
        UserGroupIcon,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon,
        ShoppingCartIcon,
        PresentationChartLineIcon,
        ClipboardCheckIcon,
        ChevronUpIcon,
        ChartBarIcon,
        CheckIcon,
        InformationCircleIcon,
        GiftIcon,
        QuestionMarkCircleIcon
    },


    setup(props) {
        const windowWidth = ref(window.innerWidth)
        const windowHeight = ref(window.innerHeight)
        const appHeight = ref(window.innerHeight)
        const isStaging = ref(window.location.href.indexOf('shark') > -1)
        const isBeta = ref(0)
        const menus = ref([]);
        let xpNextMilestone = 20
        let xpValue = 12
        let xpCurrentLevel = 1

        function addFriend(findUser) {
            axios.post(route('friend.add', {user_id: findUser.id}, {  user_id: findUser.id })).then(function(response) {
                findUser.status = 'pending'
            });
        }

        const accept = (id) => {
            axios.post(route('friend.accept'), {
                user_id: id
            })
        }
        const deny = (id) => {
            axios.post(route('friend.deny'), {
                user_id: id
            })
        }
        const query = ref('');
        let findUsers = ref({})
        const search = (query) => {
            axios.post(route('friend.search'), {
                name: query
            }).then((response) => {
                findUsers.value = response.data
                console.log(findUsers)
            })
        }

        const setWindowDimensions = () => {
            const doc = document.documentElement

            windowWidth.value = window.innerWidth
            windowHeight.value = window.innerHeight
            appHeight.value = window.innerHeight

            doc.style.setProperty('--app-height', `${appHeight}px`)
        }

        /*
        |--------------------------------------------------------------------------
        | Properties
        |--------------------------------------------------------------------------
        */
        /**
         * The VueX store.
         *
         * @type {Object}
         */
        const store = useStore()

        const gems = ref(0)
        const tokens = ref(0)
        const level = ref(0)

        const message = ref('')

        const showNavBarText = ref(true)

        /**
         * The user navigation.
         *
         * @type {Reactive}
         */
        const userNavigation = reactive([
            { name: 'Your Profile', route: 'profile.show', method: 'get' },
            // { name: 'Your Account', route: 'account', method: 'get' },
            { name: 'Referrals', route: 'affiliates', method: 'get' },
            { name: 'Logout', route: 'logout', method: 'get' },
        ])

        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        /**
         * Sidebar navigation
         *
         * @type {Reactive}
         */
        const sidebarNavigation = reactive([])
            if(menus.value && menus.value.length > 0){
                sidebarNavigation = reactive(menus.value)
        }


        /**
         * Boolean value on whether sidebar is open or not.
         *
         * @type {Boolean}
         */
        const sidebarOpen = ref(false)

        /**
         * Boolean value on whether show the notifications slide out.
         *
         * @type {Boolean}
         */
        const showNotifications = ref(false)

        /**
         * Boolean value on whether mobile menu is open or not.
         *
         * @type {Boolean}
         */
        const mobileMenuOpen = ref(false)

        /**
         * Return a string indicating whether dark mode is enabled or not.
         *
         * @type {String}
         */
        const isEnabled = computed(() => {
            return store.state.global.isDark ? 'Enabled' : 'Disabled'
        })

        const notMobile = computed(() => {
            return windowWidth.value >= 1024
        })

        const unreadNotifications = computed(() => {
            let unreadCount = 0;

            if (store.state.global.notifications.length) {
                store.state.global.notifications.some(e => {
                    if (e.read_at === null) {
                        unreadCount++
                    }
                })
            }

            return unreadCount
        })

        /**
         * Whether to show the logout modal.
         *
         * @type {Boolean}
         */
        const showLogoutModal = ref(false)

        const newNotification = ref(false)

        const showToast = ref(false)

        watch(newNotification, (current, old) => {
            if (current === true) {
                showToast.value = true
            }
        })

        watch(newNotification, (current, old) => {
            if (current === true) {
                showToast.value = true
            }
        })

        const toggleNavBarText = () => {
            showNavBarText.value = !showNavBarText.value
            localStorage.setItem('showNavBarText', showNavBarText.value)
        }

        const getNavBarTextPref = () => {
            let storedPref = localStorage.getItem('showNavBarText')

            if (storedPref) {
                showNavBarText.value = (localStorage.getItem('showNavBarText') === 'true')
            }
        }

        const getMethod = (method) => {
            if (typeof method === 'string' || method instanceof String) {
                return method
            }

            return ''
        }

        const getRoute = (routeName) => {
            if (typeof routeName === 'string' || routeName instanceof String) {
                return route(routeName)
            }

            return '#'
        }

        const isLink = (routeName) => {
            if (typeof routeName === 'string' || routeName instanceof String) {
                return route().current(routeName)
            }

            return false
        }

        const getElement = (method) => {
            if (typeof method === 'string' || method instanceof String) {
                return 'link'
            }

            return 'button'
        }

        const logout = () => {
            store.dispatch('resetGlobalState')
            store.dispatch('resetPlayState')

            Inertia.post(route('logout'))
        }

        const getNotifications = () => {
            axios.get('/api/notifications')
                .then(response => {
                    store.commit('updateNotifications', response.data)
                })
        }

        const deleteNotification = (notification) => {
            axios.delete(route('notifications.destroy', notification.id))
                .then(response => {
                    store.commit('updateNotification', notification)
                })
                .catch(error => {
                    store.commit('updateNotification', notification)
                })

            getNotifications()
        }

        const updateNotification = (notification) => {
            axios.patch(route('notifications.update', notification.id))
                .then(response => {
                    Inertia.get(route(notification.data.action_route))
                })
                .catch(error => {
                    store.commit('updateNotification', notification)
                })

            getNotifications()
        }

        const viewNotifications = () => {
            showNotifications.value = !showNotifications.value

            console.log( showNotifications.value)
            console.log( !showNotifications.value)

            newNotification.value = false
        }

        const getTokens = () => {
            axios.get(route('api.tokens.index'))
                .then(response => {
                    tokens.value = response.data
                })
        }

        const getExp = () => {
            axios.get(route('api.exp.get'))
                .then(response => {
                    level.value = response.data

                })
        }

        axios.get(route('api.menu.get'))
            .then(response => {
                menus.value = response.data;
                store.commit('setMenuState', response.data)
                if(store.state.menus.menus.length>0 && store.getters.menus.length>0 && JSON.stringify(response.data) == JSON.stringify(store.getters.menus)){
                    store.commit('setMenuState', response.data)
            }
        })

        menus.value=store.getters.menus;

        const canAccess = computed(() => {
            if (route().current() === 'tokens') {
                return true
            }

            if (route().current() === 'gems') {
                return true
            }

            if (route().current() === 'account') {
                return true
            }

            if (route().current() === 'profile.show') {
                return true
            }

            if (route().current() === 'admin') {
                return true
            }

            if (route().current() === 'api-tokens.index') {
                return true
            }

            return false
        })

        /**
         * Google Tag Manage Instance.
         *
         * @type {Object}
         */
        const gtm = useGtm();

        const isMobile = computed(() => {
            if (windowWidth.value < 1024) {
                return true
            }

            return false
        })

        const containerHeight = computed(() => {
            if (isMobile.value) {
                return 'height: '+(windowHeight.value)+'px !important;'
            }

            return 'height: 100vh;';
        })

        const mobileHeight = computed(() => {
            if (isMobile.value && store.state.global.datePickerOpen) {
                return 'height: '+(windowHeight.value - 64)+'px !important;'
            }

            // if (isMobile.value){
            //     return 'height: '+(windowHeight.value - 120)+'px !important;'
            // }

            return 'height: 100vh;';
        })

        const toggleMobileClasses = () => {
            const html = document.documentElement
            const body = document.body

            if (isMobile.value && route().current() !== 'welcome') {
                html.classList.add('racingstars')
                body.classList.add('racingstars')
            } else {
                if (html.classList.contains('racingstars')) {
                    html.classList.remove('racingstars')
                }

                if (body.classList.contains('racingstars')) {
                    body.classList.remove('racingstars')
                }
            }
        }
        let sitename = "";

        getNotifications()

        /**
         * Mounted.
         */
        onMounted(() => {
            console.log(props.user.last_logged_in)

            store.dispatch('resetGlobalState')

            getTokens()
            getExp()
            getNavBarTextPref()

            toggleMobileClasses()

            setWindowDimensions()

            window.addEventListener('resize', setWindowDimensions)
            window.addEventListener('resize', toggleMobileClasses)

            store.commit('setDarkModeIfUndefined')

            setInterval(() => {
                getNotifications()
            }, 500000);

            let racingstars = props.racingstars

            if (props.user && racingstars.env === 'production') {
                gtm.trackEvent({
                    event: 'User Logged In',
                    user: {
                        name: props.user.name,
                        email: props.user.email,
                        id: props.user.uuid,
                        created_at: props.user.created_at_timestamp,
                        mobile: props.user.mobile,
                        user_hash: props.user.hash,
                        avatar: props.user.profile_photo_url,
                    }
                });
            }

            Echo.private('notifications.' + props.user.id)
                .listen('NotificationCreated', () => {
                    newNotification.value = true
                    getNotifications()
                })
                .listen('NotificationUpdated', () => {
                    getNotifications()
                })
                .listen('NotificationDeleted', () => {
                    getNotifications()
                })
                .listen('NotificationDeleted', () => {
                    getNotifications()
                })
                .listen('BetPlaced', () => {
                    getTokens()
                    getExp()
                    getNotifications()


                    message.value = 'You\'re in - Make sure you check the leaderboard to stay up to date on your picks!'

                    setTimeout(() => {
                        message.value = ''
                    }, 1000)
                })
                .listen('exchangeSuccess', () => {
                    getTokens()
                    getNotifications()

                    message.value = 'Exchange successful!'

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                })
                .listen('ProductPurchaseSuccess', () => {
                    getTokens()
                    getNotifications()

                    message.value = 'Product Purchase successful!'

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                })
                .listen('exchangeFail', () => {
                    getTokens()
                    getNotifications()

                    message.value = {'error' : 'Exchange failed, not enough credits!'}

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                })
                .listen('refreshBalances', () => {
                    getTokens()
                })
                .listen('BoostPlaced', () => {
                    message.value = 'Boost placed!'

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                })
                .listen('BoostRemoved', () => {
                    message.value = 'Boost removed and refunded!'

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                })
                .listen('BoostError', () => {
                    message.value = {'error' : 'Boosts cannot be adjusted within 15 minutes of a meeting starting.'}

                    setTimeout(() => {
                        message.value = ''
                    }, 5000)
                });


            setInterval(() => {
                if (!sessionReminderLastShownAt) {
                    store.commit('setSessionReminderLastShownAt')
                }

                let sessionReminderLastShownAt = moment(store.state.global.sessionReminderLastShownAt).add(1, 'hour')

                if (moment() > sessionReminderLastShownAt && !showLogoutModal.value) {
                    store.commit('setSessionReminderLastShownAt')

                    showLogoutModal.value = true
                }
            }, 10000)

            let apiTokens = { name: 'API Tokens', route: 'api-tokens.index', method: 'get' }
            let admin = { name: 'Admin', route: '/admin', method: 'get' }

            // let play = { name: 'Play', route: 'play', icon: PlayIcon, method: 'get' }

            // if (!props.user.active_bet && props.user.play_tokens) {
            //     sidebarNavigation.push(play)
            // }

            if (!props.user.play_tokens && !canAccess.value && !props.user.has_bets) {
                props.inertia.get(route('tokens'))
            }
            sitename = racingstars.site;

        })

        return {
            sitename,
            sidebarOpen,
            sidebarNavigation,
            userNavigation,
            mobileMenuOpen,
            isEnabled,
            store,
            formatter,
            moment,
            showLogoutModal,
            showNotifications,
            deleteNotification,
            updateNotification,
            newNotification,
            unreadNotifications,
            viewNotifications,
            logout,
            showToast,
            canAccess,
            notMobile,
            getMethod,
            getRoute,
            getElement,
            isLink,
            mobileHeight,
            containerHeight,
            isMobile,
            windowHeight,
            windowWidth,
            isStaging,
            tokens,
            level,
            message,
            xpNextMilestone,
            xpValue,
            xpCurrentLevel,
            showNavBarText,
            toggleNavBarText,
            accept,
            deny,
            addFriend,
            search,
            findUsers,
            query,
            gems,
            menus,
            isBeta,
        }
    },

    mounted() {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i) && navigator.userAgent.match(/AppleWebKit/i)) {
            // Safari bottom navigation bar is visible
            this.isSafariWithNav = true;
        } else {
            // Safari bottom navigation bar is not visible or not using Safari
            this.isSafariWithNav = false;
        }
    },

    data() {
        return {
            isSafariWithNav: false
        };
    },
}

</script>
